




































































































































































import Component, { mixins } from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import FormValidationMixin from '@/mixins/FormValidationMixin';
import FormInput from '@/components/form/FormInput.vue';
import { Validations } from 'vuelidate-property-decorators';
import { PasswordFormData, PasswordRequest } from '@/model/Profile';
import { not, required, sameAs } from 'vuelidate/lib/validators';
import { passwordValidation } from '@/mixins/validations/password-validation';

@Component({
    components: {
        FormInput,
    },
})
export default class PasswordForm extends mixins(FormValidationMixin) {
    @Prop({ default: false, type: Boolean }) isAdmin?: boolean;

    formData = {
        oldPassword: '',
        password: '',
        passwordAgain: '',
    } as PasswordFormData;

    @Validations()
    validations(): unknown {
        if (!this.isAdmin) {
            return {
                formData: {
                    oldPassword: {
                        required,
                    },
                    password: {
                        ...passwordValidation,
                        notSameAs: not(sameAs('oldPassword')),
                    },
                    passwordAgain: {
                        required,
                        sameAs: sameAs('password'),
                    },
                },
            };
        }
        return {
            formData: {
                password: {
                    ...passwordValidation,
                    notSameAs: not(sameAs('oldPassword')),
                },
                passwordAgain: {
                    required,
                    sameAs: sameAs('password'),
                },
            },
        };
    }

    @Emit()
    submit(): PasswordRequest {
        const request = {
            oldPassword: this.formData.oldPassword,
            password: this.formData.password,
        } as PasswordRequest;
        return request;
    }
}
